module.exports = __webpack_public_path__ + "img/dengji0.c3a603d1.png";